<template>
    <div :style="boxStyle" class="ProjectNews">
        <ul ref="ulNode" @mouseenter="enterULFn" @mouseleave="leaveULFn">
            <li ref="liNode"
                :style="{
                    'min-height': liStyle['line-height'],
                    ...liStyle
                }"
                v-for="(item,index) in configBoard"
                :key="index"
                @mouseenter="spanFn($event.target[firstChild])"
                @mouseleave="leaveFn($event.target[firstChild])"
            >
                <slot :data="item" name="default">
                  <span @click.stop="clickSpanFn(item)">{{ filterItem(item) }}</span>
                </slot>
            </li>
            <li
                :style="{
                    'min-height': liStyle['line-height'],
                    ...liStyle
                }"
                v-for="(item,index) in Redundant"
                :key="`Redundant--${index}`"
                @mouseenter="spanFn($event.target[firstChild])"
                @mouseleave="leaveFn($event.target[firstChild])"
            >
                <slot :data="item" name="default">
                  <span @click.stop="clickSpanFn(item)">{{ filterItem(item) }}</span>
                </slot>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'ScrollText',
    methods: {
        clickSpanFn(item){
            this.$emit('clickSpanFn', item);
        },
        filterItem(value){
            return value instanceof Object ? value[this.showName] : value
        },
        spanFn (event) {
            cancelAnimationFrame(this.timer)
            const spanWidth = event.offsetWidth
            const liWidth = this.$refs.liNode[0].offsetWidth
            if(spanWidth > liWidth){
                this.timer = requestAnimationFrame(this.spanAnimation.bind(this, event, spanWidth))
            }
        },
        spanAnimation (spanNode, spanWidth) {
            const spanNodeMarginLeft = window.getComputedStyle(spanNode).marginLeft.slice(0, -2)
            spanNode.style.marginLeft = (spanNodeMarginLeft - 1) + 'px'
            if (Math.abs(spanNodeMarginLeft - 1) > spanWidth) {
                spanNode.style.marginLeft = 0
            }
            this.timer = requestAnimationFrame(this.spanAnimation.bind(this, spanNode, spanWidth))
        },
        enterULFn () {
            cancelAnimationFrame(this.timer)
        },
        leaveULFn () {
            if(this.configBoard.length > parseInt(this.$el.offsetHeight / this.$refs.liNode[0].offsetHeight)){
                this.timer = requestAnimationFrame(this.fn)
            }
        },
        leaveFn (event) {
            cancelAnimationFrame(this.timer)
            event.style.marginLeft = 0;
        },
        time (nowtime) {
            if(this.start === undefined){
                this.start = nowtime;
            }
            const eslit = nowtime - this.start;
            if(eslit < 2000){
                this.timer = requestAnimationFrame(this.time)
            }else{
                cancelAnimationFrame(this.timer)
                this.timer = requestAnimationFrame(this.fn)
            }
        },
        fn () {
            this.$refs.ulNode.style.top = (this.$refs.ulNode.style.top.slice(0,-3) - 0.01) + 'rem';
            if(Number.isInteger((Number(this.$refs.ulNode.style.top.slice(0,-3)) * 1000) / (Number(this.liStyle['line-height'].slice(0,-3)) * 1000))){
                cancelAnimationFrame(this.timer);
                if((Number(this.$refs.ulNode.style.top.slice(0,-3)) * 1000) / (Number(this.liStyle['line-height'].slice(0,-3)) * 1000) == -this.configBoard.length){
                    this.$refs.ulNode.style.top = 0;
                }
                this.start = undefined;
                this.timer = requestAnimationFrame(this.time)
            }else{
                this.timer = requestAnimationFrame(this.fn)
            }
        }
    },
    watch: {
        'loadData': {
            async handler(value) {
                cancelAnimationFrame(this.timer);
                this.Redundant = [];
                this.configBoard = await value;
                if(this.configBoard.length){
                    this.$nextTick(() => {
                        if(this.configBoard.length > parseInt(this.$el.offsetHeight / this.$refs.liNode[0].offsetHeight)){
                            this.Redundant = this.configBoard.slice(0, parseInt(this.$el.offsetHeight / this.$refs.liNode[0].offsetHeight))
                            this.fn();
                        }
                    })
                }
            },
            deep: true,
            immediate: true
        }
    },
    data(){
        return {
            Redundant: new Array(),
            timer: null,
            configBoard: [],
            start: undefined
        }
    },
    beforeDestroy(){
        cancelAnimationFrame(this.timer);
    },
    props:{
        BoxNode: Object,
        ulNode: Object,
        firstChild: {
            type: String,
            default: 'firstChild'
        },
        boxStyle: {
            type: Object,
            default(){
                return {}
            }
        },
        liStyle: {
            type: Object,
            default(){
                return {
                    'font-size': '0.14rem',
                    'line-height': '0.18rem'
                }
            }
        },
        showName: String,
        loadData: Promise
    }
}
</script>
<style lang="less" scoped>
    .ProjectNews{
        height: 100%;
        width: 100%;
        overflow: hidden;
        position: relative;
        ul{
            position: absolute;
            width: 100%;
            top: 0;
            li{
                list-style: none;
                color: #ffffff;
                text-align: left;
                white-space: nowrap;
                span{
                    margin-left: 0;
                }
            }
        }
    }
</style>